import { render, staticRenderFns } from "./referential-insurancetypes.vue?vue&type=template&id=22a18f00&"
import script from "./referential-insurancetypes.vue?vue&type=script&lang=ts&"
export * from "./referential-insurancetypes.vue?vue&type=script&lang=ts&"
import style0 from "./referential-insurancetypes.vue?vue&type=style&index=0&id=22a18f00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports